export default "__VITE_ASSET__DsPAvRrD__"